// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/checkbox_off.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/checkbox_on.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

html {
  background-color: #000000;

    /* Firefox - Hides track and changes thumb color */
    scrollbar-color: hsla(0, 0%, 46%, 0.5) transparent;
}

body {
  font-family: "Open Sans", sans-serif;
  background-color: #F5F5F5;
  margin: 0;
  font-family: "Open Sans";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.group:after {
  content: "";
  display: table;
  clear: both;
}

input, select, textarea {
  width: 100%;
  max-width: 250px;
  height: 35px;
  color: #000000;
  border: 1px solid #aeb0b9;
  border-radius: 8px;
  outline: none;
  background-color: #ffffff;
  padding-left: 15px;
  padding-right: 15px;
}

textarea {
  height: 100px;
  border: 1px solid #aeb0b9;
}

input.notvalid {
	border: 1px solid #FFD54F;
}

select.notvalid {
	border: 1px solid #FFD54F;
}

textarea.notvalid {
	border: 1px solid #FFD54F;
}


button {
  width: 100%;
  max-width: 200px;
  height: 45px;
  font-size: 11px;
  color: black;
  border: none;
  border-radius: 25px;
  outline: none;
  background-color: #FFD54F;
  padding-left: 15px;
  padding-right: 15px;
}

input[type=checkbox]{
  display:none;
}

input[type=checkbox] + label{
  background:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  padding: 10px 0 0 50px;
  /* height: 100%; */
  min-height: 60px;
  background-position-y: -15px;
  cursor: pointer;
  padding-top: 8px;
}


input[type=checkbox]:checked + label{
   background:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  padding: 10px 0 0 50px;
  /* height: 100%; */
  min-height: 60px;
  background-position-y: -15px;
  cursor: pointer;
  padding-top: 8px;
}

#avp-cms-screen-container {
	height: 100%;
	padding-bottom: 100px;
}

#avp-gestionesistema-screen,
#avp-gestioneutenti-screen,
#avp-gestionecontenuti-screen,
#avp-dashboard-screen,
#avp-gestioneavp-screen
 {
  display: flex;
  flex-direction: column;
  /*height: 100%;*/
  background: #F5F5F5;
}


#avp-cms-screen-container {
  height: 100%;
  padding: 25px;
  padding-bottom: 100px;
  background: #F5F5F5;
}

.avp-cms-screen-title {
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  
}

.avp-cms-screen-content {
  margin-top: 25px;
}

.avp-cms-screen-content-col50 {
  position: relative;
  float: left;
  width: 50%;
}

.avp-cms-screen-toolbar {
  padding-top: 20px;
  padding-bottom: 20px;
}

.avp-cms-screen-toolbar-title {
  position: relative;
  float: left;

  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: left;

}

.avp-cms-screen-toolbar-filters {
  position: relative;
  float: left;
}

.avp-cms-screen-toolbar-add {
  position: relative;
  float: right;
}

.avp-cms-screen-toolbar-add button {
  min-width: 200px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.MuiDataGrid-filler {
  background-color: #F5F5F5;
}

.tableHeader {
  background-color: #F5F5F5;
  color: #000000;
  font-weight: 600 !important;
}

.tableRow {
  background-color: #FFFFFF;
  color: #000000;
  font-weight: 400;
}

.tableStatusActive {
  width: 18px;
  height: 100%;
  background-color: #03A682;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.tableStatusInactive {
  width: 18px;
  height: 100%;
  background-color: #A5A5A5;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.tableActionButton img {
  margin-left: 10px;
  cursor: pointer;
}

.tableActionSmallButton img {
  margin-left: 6px;
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.MuiDataGrid-root .MuiDataGrid-cell:focus-within {
  outline: none !important;
}

.MuiTablePagination-input {
    margin-top: -12px;
}

.MuiTablePagination-actions {
  margin-top: -12px;
}

.MuiTablePagination-actions button {
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;

}

.avp-cms-screen-section-title {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: left;
  padding-top: 20px;
  padding-bottom: 20px;
}

.avp-cms-screen-content-row {
  margin-bottom: 20px;
}

.avp-cms-screen-content-column {
  position: relative;
  float: left;
  margin-right: 30px;
}

label {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: #9A9A9A;  
}

label.required:after {
  content: ' *';
  color: #FFD54F;
}

.avp-cms-tab {
  padding-top: 10p;
  padding-bottom: 20px;
}

.avp-cms-tab-item {
  position: relative;
  float: left;
  margin-right: 20px;
  color: #FFD54F;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.avp-cms-tab-item-selected {
  border-bottom: 2px solid #FFD54F;
  cursor: default;
  
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;;IAEvB,kDAAkD;IAClD,kDAAkD;AACtD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,SAAS;EACT,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;;AAGA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4DAA2D;EAC3D,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;;AAGA;GACG,4DAA0D;EAC3D,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;CACC,YAAY;CACZ,qBAAqB;AACtB;;AAEA;;;;;;EAME,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;;EAEX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;;AAEX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,eAAe;;AAEjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nhtml {\r\n  background-color: #000000;\r\n\r\n    /* Firefox - Hides track and changes thumb color */\r\n    scrollbar-color: hsla(0, 0%, 46%, 0.5) transparent;\r\n}\r\n\r\nbody {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  background-color: #F5F5F5;\r\n  margin: 0;\r\n  font-family: \"Open Sans\";\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.group:after {\r\n  content: \"\";\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\ninput, select, textarea {\r\n  width: 100%;\r\n  max-width: 250px;\r\n  height: 35px;\r\n  color: #000000;\r\n  border: 1px solid #aeb0b9;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  background-color: #ffffff;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\ntextarea {\r\n  height: 100px;\r\n  border: 1px solid #aeb0b9;\r\n}\r\n\r\ninput.notvalid {\r\n\tborder: 1px solid #FFD54F;\r\n}\r\n\r\nselect.notvalid {\r\n\tborder: 1px solid #FFD54F;\r\n}\r\n\r\ntextarea.notvalid {\r\n\tborder: 1px solid #FFD54F;\r\n}\r\n\r\n\r\nbutton {\r\n  width: 100%;\r\n  max-width: 200px;\r\n  height: 45px;\r\n  font-size: 11px;\r\n  color: black;\r\n  border: none;\r\n  border-radius: 25px;\r\n  outline: none;\r\n  background-color: #FFD54F;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\ninput[type=checkbox]{\r\n  display:none;\r\n}\r\n\r\ninput[type=checkbox] + label{\r\n  background:url('/public/images/checkbox_off.svg') no-repeat;\r\n  padding: 10px 0 0 50px;\r\n  /* height: 100%; */\r\n  min-height: 60px;\r\n  background-position-y: -15px;\r\n  cursor: pointer;\r\n  padding-top: 8px;\r\n}\r\n\r\n\r\ninput[type=checkbox]:checked + label{\r\n   background:url('/public/images/checkbox_on.svg') no-repeat;\r\n  padding: 10px 0 0 50px;\r\n  /* height: 100%; */\r\n  min-height: 60px;\r\n  background-position-y: -15px;\r\n  cursor: pointer;\r\n  padding-top: 8px;\r\n}\r\n\r\n#avp-cms-screen-container {\r\n\theight: 100%;\r\n\tpadding-bottom: 100px;\r\n}\r\n\r\n#avp-gestionesistema-screen,\r\n#avp-gestioneutenti-screen,\r\n#avp-gestionecontenuti-screen,\r\n#avp-dashboard-screen,\r\n#avp-gestioneavp-screen\r\n {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /*height: 100%;*/\r\n  background: #F5F5F5;\r\n}\r\n\r\n\r\n#avp-cms-screen-container {\r\n  height: 100%;\r\n  padding: 25px;\r\n  padding-bottom: 100px;\r\n  background: #F5F5F5;\r\n}\r\n\r\n.avp-cms-screen-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  line-height: 24px;\r\n  text-align: left;\r\n  \r\n}\r\n\r\n.avp-cms-screen-content {\r\n  margin-top: 25px;\r\n}\r\n\r\n.avp-cms-screen-content-col50 {\r\n  position: relative;\r\n  float: left;\r\n  width: 50%;\r\n}\r\n\r\n.avp-cms-screen-toolbar {\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.avp-cms-screen-toolbar-title {\r\n  position: relative;\r\n  float: left;\r\n\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 30px;\r\n  text-align: left;\r\n\r\n}\r\n\r\n.avp-cms-screen-toolbar-filters {\r\n  position: relative;\r\n  float: left;\r\n}\r\n\r\n.avp-cms-screen-toolbar-add {\r\n  position: relative;\r\n  float: right;\r\n}\r\n\r\n.avp-cms-screen-toolbar-add button {\r\n  min-width: 200px;\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n\r\n.MuiDataGrid-filler {\r\n  background-color: #F5F5F5;\r\n}\r\n\r\n.tableHeader {\r\n  background-color: #F5F5F5;\r\n  color: #000000;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.tableRow {\r\n  background-color: #FFFFFF;\r\n  color: #000000;\r\n  font-weight: 400;\r\n}\r\n\r\n.tableStatusActive {\r\n  width: 18px;\r\n  height: 100%;\r\n  background-color: #03A682;\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n}\r\n.tableStatusInactive {\r\n  width: 18px;\r\n  height: 100%;\r\n  background-color: #A5A5A5;\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n}\r\n\r\n.tableActionButton img {\r\n  margin-left: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tableActionSmallButton img {\r\n  margin-left: 6px;\r\n  cursor: pointer;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.MuiDataGrid-root .MuiDataGrid-cell:focus-within {\r\n  outline: none !important;\r\n}\r\n\r\n.MuiTablePagination-input {\r\n    margin-top: -12px;\r\n}\r\n\r\n.MuiTablePagination-actions {\r\n  margin-top: -12px;\r\n}\r\n\r\n.MuiTablePagination-actions button {\r\n  width: auto;\r\n  height: auto;\r\n  padding: 0;\r\n  margin: 0;\r\n\r\n}\r\n\r\n.avp-cms-screen-section-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 30px;\r\n  text-align: left;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.avp-cms-screen-content-row {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.avp-cms-screen-content-column {\r\n  position: relative;\r\n  float: left;\r\n  margin-right: 30px;\r\n}\r\n\r\nlabel {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  color: #9A9A9A;  \r\n}\r\n\r\nlabel.required:after {\r\n  content: ' *';\r\n  color: #FFD54F;\r\n}\r\n\r\n.avp-cms-tab {\r\n  padding-top: 10p;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.avp-cms-tab-item {\r\n  position: relative;\r\n  float: left;\r\n  margin-right: 20px;\r\n  color: #FFD54F;\r\n  cursor: pointer;\r\n  border-bottom: 2px solid transparent;\r\n}\r\n\r\n.avp-cms-tab-item-selected {\r\n  border-bottom: 2px solid #FFD54F;\r\n  cursor: default;\r\n  \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
